let insightsRatePlansApiBody = {
    "requestId": "e05daaed-6313-47f1-9706-9e833dd9b589",
    "payload": {
      "computationType": "MONTHLY_PROJECTED",
      "totalUsage": 1000.0,
      "comparedRates": [{
        "utilityId": 10008,
        "planNumber": 3,
        "dataPoints": 12,
        "expectedDataPoints": 12,
        "extrapolatedDataPoints": 0,
        "totalCost": 660.0,
        "costBreakdown": {
          "consumptionBasedCharge": 300.0,
          "dailyFixedCharges": {
            "DF3": 90.0,
            "DF2": 60.0,
            "DF1": 30.0
          },
          "monthlyFixedCharges": {
            "MF2": 60.0,
            "MF1": 30.0,
            "MF3": 90.0
          }
        },
        "savings": 0.0,
        "resources": {
          "utilityId": 10008,
          "planNumber": 3,
          "planName": "RSN0",
          "description": "One price for your first tier of usage, and a higher price for your second tier of usage -- just like different brackets for tax rates",
          "switchPlanCtaUrl": "https://www.google.com/",
          "learnMoreCtaUrl": "https://www.google.com/",
          "graphImageUrl": "https://d12of87xj1f8rc.cloudfront.net/rate-images/graph3.png",
          "rateCandidateRequirements": [{
            "id": 1,
            "type": "POSITIVE",
            "description": "Often uses energy on summer weekday afternoons."
          }, {
            "id": 3,
            "type": "POSITIVE",
            "description": "Minimizes the overall energy they use."
          }, {
            "id": 4,
            "type": "NEGATIVE",
            "description": "Doesn’t have highly energy-intensive appliances"
          }]
        },
        "isCurrentRate": false,
        "isHighestSavings": false
      }, {
        "utilityId": 10008,
        "planNumber": 1,
        "dataPoints": 12,
        "expectedDataPoints": 12,
        "extrapolatedDataPoints": 0,
        "totalCost": 220.0,
        "costBreakdown": {
          "consumptionBasedCharge": 100.0,
          "dailyFixedCharges": {
            "DF3": 30.0,
            "DF2": 20.0,
            "DF1": 10.0
          },
          "monthlyFixedCharges": {
            "MF2": 20.0,
            "MF1": 10.0,
            "MF3": 30.0
          }
        },
        "savings": -440.0,
        "resources": {
          "utilityId": 10008,
          "planNumber": 1,
          "planName": "CSN0",
          "description": "The same standard price every hour of every day",
          "switchPlanCtaUrl": "https://www.google.com/",
          "learnMoreCtaUrl": "https://www.google.com/",
          "graphImageUrl": "https://d12of87xj1f8rc.cloudfront.net/rate-images/graph1.png",
          "rateCandidateRequirements": [{
            "id": 1,
            "type": "POSITIVE",
            "description": "Often uses energy on summer weekday afternoons."
          }, {
            "id": 2,
            "type": "NEGATIVE",
            "description": "Doesnt have programmable or smart appliances"
          }]
        },
        "isCurrentRate": false,
        "isHighestSavings": false
      }, {
        "utilityId": 10008,
        "planNumber": 2,
        "dataPoints": 12,
        "expectedDataPoints": 12,
        "extrapolatedDataPoints": 0,
        "totalCost": 440.0,
        "costBreakdown": {
          "consumptionBasedCharge": 200.0,
          "dailyFixedCharges": {
            "DF3": 60.0,
            "DF2": 40.0,
            "DF1": 20.0
          },
          "monthlyFixedCharges": {
            "MF2": 40.0,
            "MF1": 20.0,
            "MF3": 60.0
          }
        },
        "savings": -220.0,
        "resources": {
          "utilityId": 10008,
          "planNumber": 2,
          "planName": "CSN2",
          "description": "High prices from 1-7pm on summer weekdays, and discounted prices at all other days and times",
          "switchPlanCtaUrl": "https://www.google.com/",
          "learnMoreCtaUrl": "https://www.google.com/",
          "graphImageUrl": "https://d12of87xj1f8rc.cloudfront.net/rate-images/graph2.png",
          "rateCandidateRequirements": [{
            "id": 1,
            "type": "POSITIVE",
            "description": "Often uses energy on summer weekday afternoons."
          }, {
            "id": 2,
            "type": "NEGATIVE",
            "description": "Doesnt have programmable or smart appliances"
          }, {
            "id": 3,
            "type": "POSITIVE",
            "description": "Minimizes the overall energy they use."
          }]
        },
        "isCurrentRate": false,
        "isHighestSavings": false
      }, {
        "utilityId": 10008,
        "planNumber": 4,
        "dataPoints": 12,
        "expectedDataPoints": 12,
        "extrapolatedDataPoints": 0,
        "totalCost": 880.0,
        "costBreakdown": {
          "consumptionBasedCharge": 400.0,
          "dailyFixedCharges": {
            "DF3": 120.0,
            "DF2": 80.0,
            "DF1": 40.0
          },
          "monthlyFixedCharges": {
            "MF2": 80.0,
            "MF1": 40.0,
            "MF3": 120.0
          }
        },
        "savings": -220.0,
        "resources": {
          "utilityId": 0,
          "planNumber": 0,
          "planName": "RSN2",
          "description": "High prices from 1-7pm on summer weekdays, and discounted prices at all other days and times",
          "switchPlanCtaUrl": "https://www.google.com/",
          "learnMoreCtaUrl": "https://www.google.com/",
          "graphImageUrl": "https://d12of87xj1f8rc.cloudfront.net/rate-images/graph2.png",
          "rateCandidateRequirements": [{
            "id": 1,
            "type": "POSITIVE",
            "description": "Often uses energy on summer weekday afternoons."
          }, {
            "id": 2,
            "type": "NEGATIVE",
            "description": "Doesnt have programmable or smart appliances"
          }, {
            "id": 3,
            "type": "POSITIVE",
            "description": "Minimizes the overall energy they use."
          }]
        },
        "isCurrentRate": false,
        "isHighestSavings": false
      }],
      "comparisonDurationStart": 1596240000,
      "comparisonDurationEnd": 1627776000
    },
    "error": null
}

export default insightsRatePlansApiBody;